import { keyframes } from '@emotion/react';
import { OriflameSpinner } from '@ori-ui/icons';
import { styled } from '@ori-ui/mui';

import { centeredFlexStyles } from '../../constants';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Root = styled('div')(centeredFlexStyles);

export const Spinner = styled(OriflameSpinner)({
  animation: `${spin} 1s linear infinite`,
});
